// extracted by mini-css-extract-plugin
module.exports = {"search-form":"M_dG flex-grow-1 form-group mb-0"};